import type { OnInit } from '@angular/core';
import { LazyImgDirective } from '@core-mkt/services/lazy-load/lazy-load.directive';
import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import type { ComponentTheme, ThemeInterface } from '@core-mkt/services/theme-parser/theme-parser.service';
import { ThemeParserService } from '@core-mkt/services/theme-parser/theme-parser.service';
import { WysiwygRedactorService } from '@core-mkt/services/wysiwg-redactor/wysiwyg-redactor.service';
import { MultiIconComponentType } from './multi-icon';

@Component({
  selector: 'multi-icon',
  templateUrl: './multi-icon.component.html',
  standalone: true,
  imports: [CommonModule, LazyImgDirective],
})
export class MultiIconComponent implements OnInit {
  @Input() data: MultiIconComponentType;
  theme: ThemeInterface;

  constructor(private redactor: WysiwygRedactorService, private themeParser: ThemeParserService) {}

  ngOnInit(): void {
    if (this.data.componentTitle === null) {
      this.data.componentTitle = '';
    } else {
      this.data.componentTitle = this.redactor.bypassSanitizer(this.data.componentTitle);
    }
    const themeInput: ComponentTheme = {
      styles: this.data.styles,
      columnCount: this.data.iconList ? this.data.iconList.length : 0,
      columnDistribution: '',
    };
    this.theme = this.themeParser.getThemeClasses(themeInput);
  }

  getColumnWidthClasses(): string {
    const iconCount = this.data.iconList ? this.data.iconList.length : 0;
    for (let i = 0; i < iconCount; i++) {
      if (iconCount === 4) {
        return 'w-1/2 xl:w-1/4';
      } else if (iconCount > 4) {
        return 'w-1/2 md:w-1/3 xl:w-1/6';
      } else if (iconCount > 1) {
        return 'w-1/2 lg:w-1/' + iconCount.toString();
      } else {
        return 'w-1/' + iconCount.toString();
      }
    }
  }
}
